import { Observable } from 'rxjs/Rx'
import { combineEpics } from 'redux-observable'
import { get, postMessage, create, getUnreads } from 'store/services/messenger'
import * as authenticationDuck from 'store/ducks/authentication'
import { parseUnreadMessages, parseAndNotify } from 'store/utils/unreadMessage'

// Actions

export const THREAD_REQUEST = 'messaging/THREAD_REQUEST'
export const THREAD_SUCCESS = 'messaging/THREAD_SUCCESS'
export const THREAD_FAILURE = 'messaging/THREAD_FAILURE'

export const THREAD_CREATE_REQUEST = 'messaging/THREAD_CREATE_REQUEST'
export const THREAD_CREATE_SUCCESS = 'messaging/THREAD_CREATE_SUCCESS'
export const THREAD_CREATE_FAILURE = 'messaging/THREAD_CREATE_FAILURE'

export const THREAD_NEW_MESSAGE_REQUEST = 'messaging/THREAD_SEND_MESSAGE_REQUEST'
export const THREAD_NEW_MESSAGE_SUCCESS = 'messaging/THREAD_SEND_MESSAGE_SUCCESS'
export const THREAD_NEW_MESSAGE_FAILURE = 'messaging/THREAD_SEND_MESSAGE_FAILURE'

export const UNREAD_MESSAGES_REQUEST = 'messaging/UNREAD_MESSAGES_REQUEST'
export const UNREAD_MESSAGES_SUCCESS = 'messaging/UNREAD_MESSAGES_SUCCESS'
export const UNREAD_MESSAGES_FAILURE = 'messaging/UNREAD_MESSAGES_FAILURE'

export const NOTIFIED = 'messaging/NOTIFIED'

export const THREAD_CLEAR = 'messaging/THREAD_CLEAR'

// Reducer
const INITIAL_STATE = {
  fetch: {
    loading: false,
  },
  send: {
    loading: false,
  },
  thread: {
    entity: {
      messages: [],
    },
  },
  unread_messages: [],
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case THREAD_REQUEST:
      return {
        ...state,
        fetch: {
          loading: true,
        },
      }
    case THREAD_SUCCESS:
      return {
        ...state,
        fetch: {
          loading: false,
        },
        thread: {
          entity: action.payload,
        },
      }
    case THREAD_FAILURE:
      return {
        ...state,
        fetch: {
          loading: false,
        },
      }
    case THREAD_CREATE_REQUEST:
      return {
        ...state,
        fetch: {
          loading: true,
        },
        thread: {
          ...state.thread,
        },
      }
    case THREAD_CREATE_SUCCESS:
      return {
        ...state,
        fetch: {
          loading: false,
        },
        thread: {
          entity: action.payload,
        },
      }
    case THREAD_CREATE_FAILURE:
      return {
        ...state,
        fetch: {
          loading: false,
        },
      }
    case THREAD_NEW_MESSAGE_REQUEST:
      return {
        ...state,
        send: {
          loading: true,
        },
      }
    case THREAD_NEW_MESSAGE_SUCCESS:
      return {
        ...state,
        send: {
          loading: false,
        },
        thread: {
          entity: action.payload,
        },
      }
    case THREAD_NEW_MESSAGE_FAILURE:
      return {
        ...state,
        send: {
          loading: false,
        },
      }
    case THREAD_CLEAR:
      return {
        ...state,
        thread: {
          entity: {
            messages: [],
          },
        },
      }
    case UNREAD_MESSAGES_REQUEST:
      return {
        ...state,
      }
    case UNREAD_MESSAGES_SUCCESS:
      return {
        ...state,
        unread_messages: parseUnreadMessages(state, action.payload),
      }
    case UNREAD_MESSAGES_FAILURE:
      return {
        ...state,
      }
    case NOTIFIED:
      return {
        ...state,
        unread_messages: parseAndNotify(state, action.payload),
      }
    default:
      return state
  }
}

// Actions Creators
export const threadClear = () => ({
  type: THREAD_CLEAR,
})
export const threadRequest = (payload) => ({
  type: THREAD_REQUEST,
  payload: payload,
})

export const threadSuccess = (payload) => ({
  type: THREAD_SUCCESS,
  payload: payload,
})

export const threadFailure = (payload) => ({
  type: THREAD_FAILURE,
  payload: payload,
})

export const threadCreateRequest = (payload) => ({
  type: THREAD_CREATE_REQUEST,
  payload: payload,
})

export const threadCreateSuccess = (payload) => ({
  type: THREAD_CREATE_SUCCESS,
  payload: payload,
})

export const threadCreateFailure = (payload) => ({
  type: THREAD_CREATE_FAILURE,
  payload: payload,
})

export const threadsenMessageRequest = (payload) => ({
  type: THREAD_NEW_MESSAGE_REQUEST,
  payload: payload,
})

export const threadsenMessageSuccess = (payload) => ({
  type: THREAD_NEW_MESSAGE_SUCCESS,
  payload: payload,
})

export const threadsenMessageFailure = (payload) => ({
  type: THREAD_NEW_MESSAGE_FAILURE,
  payload: payload,
})

export const unreadMessagesRequest = (payload) => ({
  type: UNREAD_MESSAGES_REQUEST,
  payload: payload,
})

export const unreadMessagesSuccess = (payload) => ({
  type: UNREAD_MESSAGES_SUCCESS,
  payload: payload,
})

export const unreadMessagesFailure = (payload) => ({
  type: UNREAD_MESSAGES_FAILURE,
  payload: payload,
})

export const notified = (payload) => ({
  type: NOTIFIED,
  payload: payload,
})

// Epics
export const epic = combineEpics(getThreadEpic, postThreadMessageEpic, createThreadEpic, getUnreadMessagesEpic)

export function getThreadEpic(action$) {
  return action$.ofType(THREAD_REQUEST).mergeMap((action) =>
    Observable.ajax(get({ params: action.payload }))
      .map((res) => threadSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(threadFailure(errors))
        } catch (e) {
          return Observable.of(threadFailure())
        }
      }),
  )
}

export function postThreadMessageEpic(action$) {
  return action$.ofType(THREAD_NEW_MESSAGE_REQUEST).mergeMap((action) =>
    Observable.ajax(postMessage({ payload: action.payload }))
      .map((res) => threadsenMessageSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(threadsenMessageFailure(errors))
        } catch (e) {
          return Observable.of(threadsenMessageFailure())
        }
      }),
  )
}

export function createThreadEpic(action$) {
  return action$.ofType(THREAD_CREATE_REQUEST).mergeMap((action) =>
    Observable.ajax(create({ payload: action.payload }))
      .map((res) => threadCreateSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(threadCreateFailure(errors))
        } catch (e) {
          return Observable.of(threadCreateFailure())
        }
      }),
  )
}

export function getUnreadMessagesEpic(action$) {
  return action$.ofType(UNREAD_MESSAGES_REQUEST).mergeMap((action) =>
    Observable.ajax(getUnreads())
      .map((res) => unreadMessagesSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(unreadMessagesFailure(errors))
        } catch (e) {
          return Observable.of(unreadMessagesFailure())
        }
      }),
  )
}
